module.exports = __webpack_public_path__ + "static/media/re-route_icon.c1927b2c.svg";